export default {
    'Terms': 'Regulamin usługi',
    'Subscription closed at': 'Profil zamknięty:',
    'Subscription active': 'Użytkownik aktywny',
    'Subscribed at': 'Profil otwarty:',
    'Write MSISDN to login': 'Wpisz swój numer telefonu aby się zalogować',
    "Page visible only to registered users.":"Strona tylko dla zalogowanych.",
    "PLAY NOW!":"GRAJ!",
    "If you did not register for the best games, click here": "Jeśli nie jesteś uzytkownikiem, kliknij tutaj",
    "Games in category":"Gry w kategorii",
    'Your Profile': 'Twój profill',
    'My name is': 'Nazywam się',
    'Surname': 'Imię',
    'Lastname': 'Nazwisko',
    'Create your': 'Utwórz swoje',
    'new account': 'nowe konto',
    'Start': 'Start',
    'Continue': 'Dalej',
    'I\'m a': 'Jestem',
    'Sex': 'Płeć',
    'Man': 'Męczyzna',
    'Woman': 'Kobieta',
    'My age': 'Mój wiek',
    'Age': 'Wiek',
    'years old': 'lat',
    'My height': 'Mój wzrost',
    'Height': 'Wyrost',
    'My weight': 'Moja waga',
    'Weight': 'Waga',
    'My body': 'Moja budowa',
    'Body': 'Budowa',
    'Skinny': 'Smukła',
    'Average': 'Średnia',
    'Corpulent': 'Korpulentna',
    'Muscular': 'Muskularna',
    'BRSkinny': 'Smukła',
    'BRAverage': 'Średnia',
    'BRCorpulent': 'Korpu- lentna',
    'BRMuscular': 'Musku- larna',
    'My goal': 'Mój cel',
    'Goal': 'Cel',
    'Health': 'Zdrowie',
    'Endurance': 'Wytrzymałość',
    'Appearance': 'Wygląd',
    'Strength': 'Siła',
    'BRHealth': 'Zdrowie',
    'BREndurance': 'Wytrzy- małość',
    'BRAppearance': 'Wygląd',
    'BRStrength': 'Siła',
    'Skip': 'Pomiń',
    'T&C': 'Regulamin Usługi',
    'Imprint': 'O nas',
    'Help': 'Pomoc',
    'Deactivation': 'Zarządzaj kontem',
    'Profile': 'Profil',
    'Training': 'Trening',
    'Eating plan': 'Dieta',
    'Statisitc': 'Statystyka',
    'Payment': 'Opłaty',
    'Settings': 'Ustawienia',
    'Save': 'Zapisać',
    'Training Days': 'Dni treningu',
    'Days': 'Dni',
    'Streak': 'Streak',
    'Points': 'Punkty',
    'Finished Workouts': 'Zakńczone Ćwiczenia',
    'Workouts': 'Ćwiczenia',
    'O from M': '{O} z {M}',
    'Record': 'Rekord',
    'Average': 'Średnia',
    'Complete training time': 'Całkowity czas treningu',
    'W workouts with R repetitions': '{W} ćwiczeń ze {R} powtórzeniami',
    'workouts with': 'ćwiczeń ze',
    'repetitions': 'powtórzeniami',
    'S km stretch': 'Bieg na {S} km',
    'Take a break': 'Czas odpocząć',
    'Begin': 'Zaczynamy',
    'Day': 'Dzień',
    'Breakfast': 'Sniadanie',
    'Lunch': 'Obiad',
    'Dinner': 'Kolacja',
    'Vegan': 'Wegańskie',
    'Drink': 'Napój',
    'Snacks': 'Przekąska',
    'Duration': 'Czas',
    'Repetitions with B sec break': 'Powtórzenia z pauzą na {B}',
    'Difficulty': 'Poziom',
    'low': 'niski',
    'middle': 'średni',
    'high': 'wysoki',
    'You made 1 Day': 'Dałeś radę 1 dzień',
    'With protein for training success': 'Z białkiem do sukcesu treningowego',
    'The transaction was successful. Thank you for using the service.': 'Transakcja przebiegła pomyślnie. Dziękujemy za skorzystanie z usługi.',
    'You will be redirected to the site in a moment. If this does not happen in a few seconds, click Next.': 'Za chwile zostaniesz przekierowany do serwisu. Jeśli to nie nastąpi w ciągu kilku sekund, kliknij Dalej.',
    'Search terms': 'Słowa kluczowe',
    'Search': 'Szukaj',
    'Cancel': 'Anuluj',
    'Ingredients': 'Składniki',
    'Preparation': 'Przygotowanie',
    'Portions': 'Porcje',
    'Start training': 'Zacznij trening',
    'Individual exercises': 'Kolejne ćwiczenia',
    'Workouts List': 'Przykładowe treningi',
    'See more workouts': 'Przejrzyj inne treningi',
    'Easy': 'Łatwy',
    'Normal': 'Standardowy',
    'Hard': 'Trudny',
    'More': 'Więcej',
}


// WEBPACK FOOTER //
// ./src/i18n/pl.js